import React from 'react';
import Link from 'gatsby-link';
import HeaderImage from './headerImage';

const Header = ({ siteTitle }) => (
  <div style={{display: 'flex'}}>
    <HeaderImage />
    <div
      style={{
        margin: '0 auto',
        maxWidth: 960,
        padding: '1.45rem 1.0875rem',
      }}
    >
      <h1 style={{ margin: 0 }} className='site-title'>
        <Link
          to="/"
          style={{
            /* color: '#605980',*/
            color: 'red',
            fontFamily: 'sans-serif',
            textDecoration: 'none',
          }}
        >
          {siteTitle}
        </Link>
      </h1>
    </div>
  </div>
);

export default Header;



// WEBPACK FOOTER //
// ./src/components/header.js